var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f7-page",
    [
      _c(
        "b-container",
        {
          staticClass:
            "main-content homepageBackgroundImage icon-homepage-button-request-payment",
          style: _vm.backgroundImg,
          attrs: { fluid: "" },
        },
        [
          _c(
            "b-row",
            { staticClass: "homepageTextBloc1" },
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _c(
                    "transition",
                    { attrs: { name: "slide-fade-title", appear: "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "homepageTitle homepageTitleText" },
                        [
                          _c("img", {
                            staticStyle: { "margin-left": "-50px" },
                            attrs: {
                              width: "450px",
                              height: "22%",
                              src: _vm.MrBgLogo,
                              alt: "mr_logo_green",
                            },
                          }),
                          _c("span", { staticClass: "big-title" }, [
                            _vm._v("Compliance"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "slide-fade-title", appear: "" } },
            [
              _c(
                "b-row",
                { staticClass: "homepageCards" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex flex-row",
                      attrs: { cols: "2", offset: "4" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "homeCardBody homeCardBody-1 text-center",
                        },
                        [
                          _c("i", {
                            staticClass: "fa-light fa-eye",
                            staticStyle: { "font-size": "30px" },
                          }),
                          _vm._v(" "),
                          _c("h4", [
                            _vm._v(_vm._s(_vm.$t("Homepage.verify_company"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "lg" },
                              on: {
                                click: function ($event) {
                                  return _vm.redirect("/verifications/create/")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("Homepage.verify_company_do")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "d-flex flex-row", attrs: { cols: "2" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "homeCardBody homeCardBody-2 text-center",
                        },
                        [
                          _c("i", {
                            staticClass: "fa-light fa-folders",
                            staticStyle: { "font-size": "30px" },
                          }),
                          _vm._v(" "),
                          _c("h4", [
                            _vm._v(_vm._s(_vm.$t("Homepage.consult_seller"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "lg" },
                              on: {
                                click: function ($event) {
                                  return _vm.redirect("/suppliers/list")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("Homepage.consult_seller_do")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "d-flex flex-row", attrs: { cols: "2" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "homeCardBody homeCardBody-3 text-center",
                        },
                        [
                          _c("i", {
                            staticClass: "fa-light fa-check-double",
                            staticStyle: { "font-size": "30px" },
                          }),
                          _vm._v(" "),
                          _c("h4", [
                            _vm._v(
                              _vm._s(_vm.$t("Homepage.change_acceptance"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "lg" },
                              on: {
                                click: function ($event) {
                                  return _vm.redirect("/kycscores/")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("Homepage.change_acceptance_do")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "homepageTextBloc3" },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12" } },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "slide-fade-title", appear: "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "homepageSubTitle homepageSubTitleText",
                            },
                            [
                              _c("img", {
                                staticClass: "homepageSubTitleLogo",
                                attrs: { src: _vm.imgLogo },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }